var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoPayPerView = function SvgIcoPayPerView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.458 13.624a1.5 1.5 0 0 1 0-2.121.75.75 0 0 0 0-1.061l-9.9-9.9a.75.75 0 0 0-1.06 0 1.5 1.5 0 0 1-2.122 0 .75.75 0 0 0-1.06 0L.541 5.315a.75.75 0 0 0 0 1.061 1.5 1.5 0 0 1 0 2.121.75.75 0 0 0 0 1.061l9.9 9.9a.75.75 0 0 0 1.06 0 1.5 1.5 0 0 1 2.122 0 .75.75 0 0 0 1.06 0l4.774-4.773a.75.75 0 0 0 0-1.061m-9.838.198a.417.417 0 0 1-.738-.117l-.548-1.764a.42.42 0 0 0-.274-.275l-1.765-.548a.417.417 0 0 1-.117-.738l1.509-1.067a.42.42 0 0 0 .176-.345L7.839 7.12a.417.417 0 0 1 .666-.34l1.48 1.106c.11.082.254.105.384.06l1.75-.593c.326-.11.639.202.528.529l-.594 1.75a.42.42 0 0 0 .061.382l1.105 1.48a.417.417 0 0 1-.34.667l-1.846-.024a.42.42 0 0 0-.346.176z"
  })));
};
export default SvgIcoPayPerView;